module.exports = __webpack_public_path__ + "img/B10_Gambling.fc7d9aab.png";